export default {"src":"/_next/static/media/calendar-date-purple.be0d7c0c.svg","height":18,"width":20,"blurWidth":0,"blurHeight":0};